import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { PageLoader } from '../../../shared/ui/PageLoader'
import { selectSessionStatus } from '../application/session-slice'

export function RequireSession({ loginPath }: { loginPath: string }) {
  const status = useSelector(selectSessionStatus)
  const location = useLocation()

  if (status === 'unknown') {
    return <PageLoader />
  }

  if (status === 'anonymous') {
    return (
      <Navigate
        replace
        to={loginPath}
        state={{
          returnTo: `${location.pathname}${location.search}${location.hash}`,
        }}
      />
    )
  }

  return <Outlet />
}
